export enum OnboardingStepType {
  GOALS = "goals",
  INSPIRATION = "inspiration",
  PLANTS = "plants",
  WISHLIST = "wishlist",
  PHOTOS = "photos",
  REVIEW = "review",
  EXTERIOR = "exterior",

  // Toll Brothers co-branded onboarding partition (EN-5606). Toll projects are
  // seeded with these step types instead of the normal ones above; completion
  // is written explicitly (percentComplete = 100) per step. The final "Submit"
  // step reuses REVIEW (the server-side completion trigger), not a toll_* type.
  TOLL_PROPERTY = "toll_property",
  TOLL_STYLE_INSPIRATION = "toll_style_inspiration",
  TOLL_GOALS = "toll_goals",
  TOLL_WISHLIST = "toll_wishlist",
  TOLL_PRIORITIZE = "toll_prioritize",
}
